module.exports = __webpack_public_path__ + "r-v3/img/no_signal_white.95cf3593.svg";